"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Rating = _interopRequireDefault(require("ecosystem-marketplace-core/components/reviews/Rating"));

var _RatingTypes = require("ecosystem-marketplace-core/constants/reviews/RatingTypes");

var _AppReviewability = _interopRequireDefault(require("../../../records/AppReviewability"));

var _WriteReviewButton = _interopRequireDefault(require("./WriteReviewButton"));

var textPath = 'appMarketplace.detail.reviews';

var ReviewsListEmptyState = function ReviewsListEmptyState(_ref) {
  var isPreview = _ref.isPreview,
      offeringId = _ref.offeringId,
      reviewability = _ref.reviewability,
      onWriteReviewClick = _ref.onWriteReviewClick;
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: textPath + ".emptyStateHeading"
  })), _react.default.createElement(_Rating.default, {
    type: _RatingTypes.STAR_RATING_EMPTY_STATE,
    rating: 0,
    labelSize: "large",
    label: _react.default.createElement(_FormattedMessage.default, {
      message: textPath + ".reviewCount",
      options: {
        count: 0
      }
    })
  }), _react.default.createElement("div", {
    className: "m-top-8"
  }, _react.default.createElement(_WriteReviewButton.default, {
    disabled: isPreview,
    offeringId: offeringId,
    onClick: onWriteReviewClick,
    reviewability: reviewability,
    size: "md"
  })));
};

ReviewsListEmptyState.propTypes = {
  isPreview: _propTypes.default.bool.isRequired,
  offeringId: _propTypes.default.number.isRequired,
  onWriteReviewClick: _propTypes.default.func.isRequired,
  reviewability: _propTypes.default.instanceOf(_AppReviewability.default).isRequired
};
ReviewsListEmptyState.defaultProps = {
  isPreview: false
};
var _default = ReviewsListEmptyState;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/reviews/ReviewsListEmptyState.js
// module id = 432
// module chunks = 209 210 211 212